// extracted by mini-css-extract-plugin
export default {"contactusHead":"styles_contactusHead__xkKb3","cardBody":"styles_cardBody__gUsH-"};